module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Medium.5bb8910e.woff2";